 <template>
  <div>
    <div id="registeradd" ref="registeradd" :style="{ width: '100%', height: '300px' }"></div>
  </div>
</template>
<script>
// 引入基本模板
let echarts = require("echarts/lib/echarts");
// 引入柱状图组件
require("echarts/lib/chart/bar");
require("echarts/lib/chart/line");
// 引入提示框和title组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
require("echarts/lib/component/legend");
require("echarts/lib/component/dataZoom");
require("echarts/lib/component/grid");
require("echarts/lib/chart/line");
// require('echarts/lib/component/markPoint');
// require('echarts/lib/component/axisPointer');

export default {
  props: {
    regBaseMom: { Type: Array, default: () => {} },
  },

  data() {
    return {
      regBase: this.regBaseMom,
    };
  },
  created() {},
  mounted() {
    this.register();
  },

  methods: {
    register() {
      // let myChart = echarts.init(document.getElementById("registeradd"));
      if (this.$refs.registeradd) {
        setTimeout(() => {
          // 基于准备好的dom，初始化echarts实例
          let myChart = echarts.init(this.$refs.registeradd);
          // 绘制图表
          myChart.setOption({
            title: {
              text: this.regBase.name,
              // subtext:this.regBase.name,
              left: "center",
              top: 0,
              textStyle: {
                //文字颜色
                color: "#666666",
                fontStyle: "normal",
                fontSize: 15,
              },
            },
            legend: {
              data: ["送货年度数据"],
              left: "center",
              top: 30,
            },
            color: ["#90aef5", "#59b1f1"],
            tooltip: {
              trigger: "axis",
              textStyle: {
                align: "left",
              },
              axisPointer: {
                type: "line",
              },
              formatter: "{b0}<br/>{a0}:{c0}",
            },

            grid: {
              x: 45,
              y: 80,
              x2: 45,
              y2: 20,
            },

            xAxis: [
              {
                type: "category",
                data: this.regBase.date,
                axisLine: {
                  lineStyle: {
                    color: "#666", // 颜色
                  },
                },
              },
            ],
            yAxis: [
              {
                type: "value",
                name: "送货量 (pcs)",
                min: 0,
                max: Math.max.apply(null, this.regBase.vcont1.map(Number)) + 20,
                interval:
                  parseInt(
                    Math.max.apply(null, this.regBase.vcont1.map(Number)) + 20
                  ) / 5,
                axisLabel: {
                  formatter: "{value}",
                },
                axisLine: {
                  lineStyle: {
                    color: "#666", // 颜色
                  },
                },
              },
            ],
            series: [
              {
                name: "送货年度数据",
                type: "line",
                symbolSize: 8,
                symbol: "heart",
                // barWidth: 30,
                data: this.regBase.vcont1,
                itemStyle: {
                  normal: {
                    lineStyle: {
                      color: "#8085e8",
                    },
                  },
                },
              },
            ],
          });
        }, 0);
      }
    },
  },
};
</script>
